import { api } from './client'

// Hạng thành viên bán lẻ, dùng chung website + Zalo Mini App (hợp đồng v3).
// Khách ở hạng có mốc chi tiêu cao nhất đã đạt; thứ tự hạng = mốc tăng dần.

export interface ShopTier {
    id: string
    name: string
    /** Mốc chi tiêu tối thiểu (đồng, số nguyên). */
    min_spend: number
    /** Ưu đãi % trên tiền hàng (0–10, tối đa 2 chữ số thập phân). */
    discount_percent: number
    free_shipping: boolean
    /** Số tài khoản đang ở hạng — null tới khi có tài khoản khách bán lẻ. */
    account_count: number | null
    created_at: string
    updated_at: string
}

export interface ShopTierInput {
    name: string
    min_spend: number
    discount_percent: number
    free_shipping: boolean
}

export const SHOP_TIER_NAME_MAX = 50
export const SHOP_TIER_DISCOUNT_MAX = 10
export const SHOP_TIER_MIN_SPEND_MAX = 1_000_000_000_000

export const shopTierApi = {
    list: () => api.get<ShopTier[]>('/shop-admin/tiers'),
    create: (input: ShopTierInput) =>
        api.post<ShopTier>('/shop-admin/tiers', input),
    update: (id: string, input: ShopTierInput) =>
        api.put<ShopTier>(`/shop-admin/tiers/${id}`, input),
    remove: (id: string) => api.delete<null>(`/shop-admin/tiers/${id}`),
}
